export const GENERIC_ERROR_TITLE = window.jQuery ? $.__('One or more files failed to upload.') : 'One or more files failed to upload.';
export const SPECIFIC_ERROR_TITLE = window.jQuery
	? $.__('One or more files failed to upload for the following reasons:')
	: 'One or more files failed to upload for the following reasons:';
